module.exports = __webpack_public_path__ + "static/media/black_discont.cfc0f702.png";